import styled from "styled-components"

const Card = styled.div`
  background-color: ${(props) => props.theme.card};
  border: 1px solid ${(props) => props.theme.cardBorder};
  border-radius: 8px;
  overflow: hidden;
`

export default Card

